<div class="property-overlay">
  <div class="property-name-display">
    <h2 class="property-title">{{ propertyName }}</h2>
    @if (propertyData?.data && !isLoading) {
      <div class="property-quick-stats">
        @if (propertyData.data.bedrooms) {
          <span class="stat-item">
            <span class="material-icons">bed</span>
            <span class="stat-value">{{ propertyData.data.bedrooms }}</span>
          </span>
        }
        @if (propertyData.data.bathrooms) {
          <span class="stat-item">
            <span class="material-icons">bathtub</span>
            <span class="stat-value">{{ propertyData.data.bathrooms }}</span>
          </span>
        }
        @if (propertyData.data.living_area_sqft) {
          <span class="stat-item">
            <span class="material-icons">square_foot</span>
            <span class="stat-value">{{ propertyData.data.living_area_sqft | formatLocaleNumber }}</span>
          </span>
        }
      </div>
    }
    @if (isLoading) {
      <div class="property-quick-stats loading">
        <ion-skeleton-text animated style="width: 120px; height: 18px; border-radius: 4px;" />
      </div>
    }
  </div>

  <div class="info-icons-row" [class.expanded]="isExpanded">
    <button class="expand-toggle" (click)="onToggleExpand()">
      <span class="material-icons">{{ isExpanded ? 'expand_more' : 'expand_less' }}</span>
    </button>

    <div class="icons-container" [class.visible]="isExpanded">
      <button class="info-icon-btn" (click)="onIconClick('weather')" [class.has-data]="locationData?.attributes?.weather?.data">
        <span class="material-icons">{{ getWeatherIcon() }}</span>
        @if (isExpanded) {
          <span class="icon-label">{{ getWeatherLabel() || 'Weather' }}</span>
        }
      </button>

      <button class="info-icon-btn" (click)="onIconClick('electrical')" [class.has-data]="locationData?.attributes?.utility?.data?.electric">
        <span class="material-icons">bolt</span>
        @if (isExpanded) {
          <span class="icon-label">Electric</span>
        }
      </button>

      <button class="info-icon-btn" (click)="onIconClick('water')" [class.has-data]="locationData?.attributes?.utility?.data?.water">
        <span class="material-icons">water_drop</span>
        @if (isExpanded) {
          <span class="icon-label">Water</span>
        }
      </button>

      <button class="info-icon-btn" (click)="onIconClick('internet')" [class.has-data]="locationData?.attributes?.utility?.data?.internet?.length">
        <span class="material-icons">wifi</span>
        @if (isExpanded) {
          <span class="icon-label">Internet</span>
        }
      </button>

      <button class="info-icon-btn" (click)="onIconClick('trash')" [class.has-data]="locationData?.attributes?.utility?.data?.trash">
        <span class="material-icons">local_shipping</span>
        @if (isExpanded) {
          <span class="icon-label">Trash</span>
        }
      </button>

      <button class="info-icon-btn" (click)="onIconClick('ordinances')" [class.has-data]="hasOrdinancesData()">
        <span class="material-icons">gavel</span>
        @if (isExpanded) {
          <span class="icon-label">Ordinances</span>
        }
      </button>
    </div>
  </div>
</div>
